// @ts-nocheck
// get contractor links
export const GET_CONTRACTOR_LINK_REQUEST = "GET_CONTRACTOR_LINK_REQUEST";
export const GET_CONTRACTOR_LINK_SUCCESS = "GET_CONTRACTOR_LINK_SUCCESS";
export const GET_CONTRACTOR_LINK_FAILURE = "GET_CONTRACTOR_LINK_FAILURE";

// add contractor links
export const ADD_CONTRACTOR_LINK_REQUEST = "ADD_CONTRACTOR_LINK_REQUEST";
export const ADD_CONTRACTOR_LINK_SUCCESS = "ADD_CONTRACTOR_LINK_SUCCESS";
export const ADD_CONTRACTOR_LINK_FAILURE = "ADD_CONTRACTOR_LINK_FAILURE";

// delete contractor link
export const DELETE_CONTRACTOR_LINK_REQUEST = "DELETE_CONTRACTOR_LINK_REQUEST";
export const DELETE_CONTRACTOR_LINK_SUCCESS = "DELETE_CONTRACTOR_LINK_SUCCESS";
export const DELETE_CONTRACTOR_LINK_FAILURE = "DELETE_CONTRACTOR_LINK_FAILURE";

// fetch all contractor documents
export const FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST =
  "FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST";
export const FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS =
  "FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS";
export const FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE =
  "FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE";

// open view document modal
export const OPEN_VIEW_DOCUMENT_MODAL = "OPEN_VIEW_DOCUMENT_MODAL";

// close view document modal
export const CLOSE_VIEW_DOCUMENT_MODAL = "CLOSE_VIEW_DOCUMENT_MODAL";

// fetch contractor document urls
export const FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST =
  "FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST";
export const FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS =
  "FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS";
export const FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE =
  "FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE";

// fetch contractor document by id
export const FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST =
  "FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST";
export const FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS =
  "FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS";
export const FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE =
  "FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE";

// open contractor manage approvals modal
export const OPEN_MANAGE_APPROVALS_MODAL = "OPEN_MANAGE_APPROVALS_MODAL";

// close contractor manage approvals modal
export const CLOSE_MANAGE_APPROVALS_MODAL = "CLOSE_MANAGE_APPROVALS_MODAL";

// get contractor details for manage approvals
export const GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST =
  "GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST";
export const GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS =
  "GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS";
export const GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE =
  "GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE";

// update contractor data
export const UPDATE_MANAGE_APPROVAL_DATA = "UPDATE_MANAGE_APPROVAL_DATA";